@layer reset, base, tokens, recipes, utilities;

@layer reset{
  html {
    --font-fallback: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -moz-tab-size: 4;
    tab-size: 4;
    line-height: 1.5;
    font-family: var(--global-font-body, var(--font-fallback));
}

  * {
    margin: 0px;
    padding: 0px;
    font: inherit;
}

  *,*::before,*::after {
    box-sizing: border-box;
    border-width: 0px;
    border-style: solid;
    border-color: var(--global-color-border, currentColor);
}

  hr {
    height: 0px;
    color: inherit;
    border-top-width: 1px;
}

  body {
    height: 100%;
}

  img {
    border-style: none;
}

  img,svg,video,canvas,audio,iframe,embed,object {
    display: block;
    vertical-align: middle;
}

  img,video {
    max-width: 100%;
    height: auto;
}

  p,h1,h2,h3,h4,h5,h6 {
    overflow-wrap: break-word;
}

  ol,ul {
    list-style: none;
}

  code,kbd,pre,samp {
    font-size: 1em;
}

  button,[type='button'],[type='reset'],[type='submit'] {
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none;
}

  button,input,optgroup,select,textarea {
    color: inherit;
}

  button,select {
    text-transform: none;
}

  table {
    text-indent: 0px;
    border-collapse: collapse;
    border-color: inherit;
}

  input::placeholder,textarea::placeholder {
    opacity: 1;
    color: var(--global-color-placeholder, #9ca3af);
}

  textarea {
    resize: vertical;
}

  summary {
    display: list-item;
}

  small {
    font-size: 80%;
}

  sub,sup {
    position: relative;
    vertical-align: baseline;
    font-size: 75%;
    line-height: 0;
}

  sub {
    bottom: -0.25em;
}

  sup {
    top: -0.5em;
}

  dialog {
    padding: 0px;
}

  a {
    color: inherit;
    text-decoration: inherit;
}

  abbr:where([title]) {
    text-decoration: underline dotted;
}

  b,strong {
    font-weight: bolder;
}

  code,kbd,samp,pre {
    --font-mono-fallback: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New';
    font-size: 1em;
    font-family: var(--global-font-mono, var(--font-mono-fallback));
}

  input[type="text"],input[type="email"],input[type="search"],input[type="password"] {
    -webkit-appearance: none;
    -moz-appearance: none;
}

  input[type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
}

  ::-webkit-search-decoration,::-webkit-search-cancel-button {
    -webkit-appearance: none;
}

  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
}

  input[type="number"]::-webkit-inner-spin-button,input[type="number"]::-webkit-outer-spin-button {
    height: auto;
}

  input[type='number'] {
    -moz-appearance: textfield;
}

  :-moz-ui-invalid {
    box-shadow: none;
}

  :-moz-focusring {
    outline: auto;
}

  [hidden] {
    display: none !important;
}
}

@layer base{
  :root {
    --made-with-panda: '🐼';
}

  *,*::before,*::after,::backdrop {
    --blur: /*-*/ /*-*/;
    --brightness: /*-*/ /*-*/;
    --contrast: /*-*/ /*-*/;
    --grayscale: /*-*/ /*-*/;
    --hue-rotate: /*-*/ /*-*/;
    --invert: /*-*/ /*-*/;
    --saturate: /*-*/ /*-*/;
    --sepia: /*-*/ /*-*/;
    --drop-shadow: /*-*/ /*-*/;
    --backdrop-blur: /*-*/ /*-*/;
    --backdrop-brightness: /*-*/ /*-*/;
    --backdrop-contrast: /*-*/ /*-*/;
    --backdrop-grayscale: /*-*/ /*-*/;
    --backdrop-hue-rotate: /*-*/ /*-*/;
    --backdrop-invert: /*-*/ /*-*/;
    --backdrop-opacity: /*-*/ /*-*/;
    --backdrop-saturate: /*-*/ /*-*/;
    --backdrop-sepia: /*-*/ /*-*/;
    --scroll-snap-strictness: proximity;
    --border-spacing-x: 0;
    --border-spacing-y: 0;
    --translate-x: 0;
    --translate-y: 0;
    --rotate: 0;
    --skew-x: 0;
    --skew-y: 0;
    --scale-x: 1;
    --scale-y: 1;
}

  body,html {
    background-color: var(--colors-gray-4);
}

  :root {
    --swiper-pagination-color: var(--colors-green);
    --swiper-pagination-bullet-inactive-color: var(--colors-gray-1);
    --swiper-pagination-bullet-inactive-opacity: 1;
}

  .swiper-pagination-horizontal {
    direction: ltr;
}

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
}

  .rmdp-wrapper {
    box-shadow: none;
    width: 100% !important;
    min-height: 305px !important;
    font-family: iran-yekan !important;
}

  .rmdp-calendar {
    padding: 4px 0 !important;
}

  .rmdp-shadow {
    box-shadow: 0px 4px 8px 0px #bfbfbf1a !important;
}

  .rmdp-day {
    color: var(--colors-black-2) !important;
    letter-spacing: 0;
    text-decoration: None;
    text-transform: None;
    font-family: iran-yekan;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
}

  .rmdp-deactive {
    color: var(--colors-gray-1) !important;
}

  .rmdp-day-picker {
    padding: 0 !important;
}

  .rmdp-day-picker,.rmdp-top-class {
    display: block !important;
}

  .rmdp-header-values {
    margin: auto auto auto 0 !important;
    color: var(--colors-black-1) !important;
    letter-spacing: 0;
    text-decoration: None;
    text-transform: None;
    font-family: iran-yekan;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
}

  .rmdp-header {
    padding-bottom: 10px !important;
}

  .rmdp-header,.rmdp-week {
    padding-inline: 10px !important;
}

  .rmdp-week:first-of-type {
    border-bottom: 1px solid #f0f0f0 !important;
}

  .rmdp-week:not(:first-of-type) {
    padding-top: 10px !important;
}

  .rmdp-week-day {
    padding: 0 4px !important;
    color: var(--colors-black-3) !important;
}

  .rmdp-arrow {
    border-color: var(--colors-black-2) !important;
}

  .rmdp-arrow-container {
    margin: 0 0 0 20px !important;
}

  .rmdp-month-name {
    border-bottom: 1px solid #f0f0f0 !important;
    margin-bottom: 5px !important;
    padding-bottom: 5px !important;
}

  .rmdp-arrow-container:hover {
    box-shadow: none !important;
    background-color: transparent !important;
}
}

@layer tokens{
  :where(:root, :host) {
    --colors-splash: #715CAC;
    --colors-purple-primary: #7548F0;
    --colors-purple-1: #6A4BC0;
    --colors-purple-2: #8E68F6;
    --colors-purple-3: #BCA4FF;
    --colors-purple-4: #C9B9F6;
    --colors-purple-5: #E0DEF1;
    --colors-purple-6: #F0EEFF;
    --colors-purple-7: #F6F5FF;
    --colors-blue: #2D59AB;
    --colors-blue-1: #CCDEFF;
    --colors-blue-2: #CCDEFF;
    --colors-orange: #FC8210;
    --colors-orange-1: #FFC997;
    --colors-orange-2: #FFDDBD;
    --colors-orange-3: #FEF3E9;
    --colors-red: #E34C4C;
    --colors-red-1: #FC6B6B;
    --colors-red-2: #FFE5E5;
    --colors-red-3: #FFE8E8;
    --colors-green: #0DC277;
    --colors-green-1: #068F61;
    --colors-green-2: #2DAB77;
    --colors-green-3: #CAEDDA;
    --colors-green-4: #E9FEF5;
    --colors-pink: #F04866;
    --colors-pink-1: #FFD0D9;
    --colors-pink-2: #FEE9F1;
    --colors-yellow: #D9AA04;
    --colors-yellow-1: #FFF4CF;
    --colors-black: #3C3C3C;
    --colors-black-1: #646464;
    --colors-black-2: #787878;
    --colors-black-3: #A0A0A0;
    --colors-black-4: #B6B6B6;
    --colors-black-5: #BCBCBCB2;
    --colors-gray: #C2C2C2;
    --colors-gray-1: #D9D9D9;
    --colors-gray-2: #EBEBEB;
    --colors-gray-3: #F4F4F4;
    --colors-gray-4: #FAFAFA;
    --colors-white: #FFF;
    --colors-delay-linear: linear-gradient(90.71deg, #FFE8E8 5.64%, rgba(254, 238, 238, 0.31) 96.94%);
    --colors-purple-linear: linear-gradient(90.64deg, #F1F0F8 1.9%, rgba(240, 239, 252, 0.403547) 62.33%, rgba(240, 238, 255, 0) 103.21%);
    --font-sizes-xxs: 8px;
    --font-sizes-xs: 10px;
    --font-sizes-sm: 11px;
    --font-sizes-md: 12px;
    --font-sizes-lg: 14px;
    --font-sizes-xl: 16px;
    --shadows-card-shadow: 0px 4px 8px 0px #BFBFBF1A;
    --shadows-header-shadow: 0px 4px 8px 0px #BCBCBC26;
    --fonts-iran-yekan: var(--font-iran-yekan), sans-serif;
    --fonts-iran-yekan-bold: var(--font-iran-yekan-bold), sans-serif;
    --z-index-layout: 1;
    --z-index-modal: 2;
    --z-index-toast: 3;
    --z-index-map-extension: 400;
    --z-index-camera: 4;
    --z-index-camera-layout: 5;
    --sizes-max-container: 450px;
    --sizes-breakpoint-2xl: 1536px;
    --sizes-breakpoint-sm: 375px;
    --sizes-breakpoint-md: 390px;
    --sizes-breakpoint-lg: 412px;
    --sizes-breakpoint-xl: 450px;
    --font-weights-medium: 500;
    --font-weights-bold: 700;
    --radii-none: 0px;
    --radii-small: 4px;
    --radii-medium: 8px;
    --radii-large: 16px;
    --radii-rounded: 9999px;
    --breakpoints-2xl: 1536px;
    --breakpoints-sm: 375px;
    --breakpoints-md: 390px;
    --breakpoints-lg: 412px;
    --breakpoints-xl: 450px;
}

  @keyframes spin {
    to {
      transform: rotate(360deg);
}
}

  @keyframes ping {
    75%,100% {
      transform: scale(2);
      opacity: 0;
}
}

  @keyframes pulse {
    50% {
      opacity: 0.5;
}
}

  @keyframes bounce {
    0%,100% {
      transform: translateY(-25%);
      animation-timing-function: cubic-bezier(0.8,0,1,1);
}

    50% {
      transform: none;
      animation-timing-function: cubic-bezier(0,0,0.2,1);
}
}
}

@layer utilities{
  @layer compositions{
    .textStyle_b1 {
      font-size: 14px;
      line-height: 32px;
}

    .textStyle_b1,.textStyle_b2 {
      letter-spacing: 0;
      text-decoration: None;
      text-transform: None;
      font-family: iran-yekan;
      font-weight: 500;
}

    .textStyle_b2 {
      font-size: 12px;
      line-height: 24px;
}

    .textStyle_b4 {
      font-size: 11px;
      line-height: 24px;
}

    .textStyle_b4,.textStyle_h2 {
      letter-spacing: 0;
      text-decoration: None;
      text-transform: None;
      font-family: iran-yekan-bold;
      font-weight: 700;
}

    .textStyle_h2 {
      font-size: 14px;
      line-height: 20px;
}

    .textStyle_h1 {
      font-family: iran-yekan;
      font-weight: 500;
      font-size: 16px;
}

    .textStyle_h1,.textStyle_b3 {
      letter-spacing: 0;
      text-decoration: None;
      text-transform: None;
      line-height: 24px;
}

    .textStyle_b3 {
      font-family: iran-yekan-bold;
      font-weight: 700;
      font-size: 10px;
}
}

  .w_100\% {
    width: 100%;
}

  .d_flex {
    display: flex;
}

  .gap_1rem {
    gap: 1rem;
}

  .m_auto {
    margin: auto;
}

  .w_330px {
    width: 330px;
}

  .gap_5px {
    gap: 5px;
}

  .p_2rem {
    padding: 2rem;
}

  .p_1rem {
    padding: 1rem;
}

  .h_200px {
    height: 200px;
}

  .border_1px_solid_\#ccc {
    border: 1px solid #ccc;
}

  .rounded_10px {
    border-radius: 10px;
}

  .stroke_\#ff0000 {
    stroke: #ff0000;
}

  .h_70vh {
    height: 70vh;
}

  .text_colors\.purple-primary {
    color: colors.purple-primary;
}

  .pos_relative {
    position: relative;
}

  .w_16px {
    width: 16px;
}

  .h_16px {
    height: 16px;
}

  .d_block {
    display: block;
}

  .appearance_none {
    appearance: none;
    -webkit-appearance: none;
}

  .h_100\% {
    height: 100%;
}

  .rounded_2px {
    border-radius: 2px;
}

  .border_1px_solid_\{colors\.black-4\} {
    border: 1px solid var(--colors-black-4);
}

  .pos_absolute {
    position: absolute;
}

  .w_12px {
    width: 12px;
}

  .h_9px {
    height: 9px;
}

  .stroke_white {
    stroke: var(--colors-white);
}

  .p_20px {
    padding: 20px;
}

  .gap_15px {
    gap: 15px;
}

  .my_8 {
    margin-block: 8px;
}

  .rounded_8px {
    border-radius: 8px;
}

  .shadow_cardShadow {
    box-shadow: var(--shadows-card-shadow);
}

  .h_32px {
    height: 32px;
}

  .h_26px {
    height: 26px;
}

  .text_nowrap {
    text-wrap: nowrap;
}

  .w_350px {
    width: 350px;
}

  .text_primary {
    color: primary;
}

  .cursor_pointer {
    cursor: pointer;
}

  .gap_16px {
    gap: 16px;
}

  .gap_6px {
    gap: 6px;
}

  .p_4px_8px {
    padding: 4px 8px;
}

  .d_inline-block {
    display: inline-block;
}

  .text_black-3 {
    color: var(--colors-black-3);
}

  .text_\#D9AA04 {
    color: #D9AA04;
}

  .w_12 {
    width: 12px;
}

  .h_12 {
    height: 12px;
}

  .cursor_not-allowed {
    cursor: not-allowed;
}

  .p_10px {
    padding: 10px;
}

  .gap_8px {
    gap: 8px;
}

  .text_black-1 {
    color: var(--colors-black-1);
}

  .text_gray {
    color: var(--colors-gray);
}

  .rounded_4px {
    border-radius: 4px;
}

  .px_10px {
    padding-inline: 10px;
}

  .py_2px {
    padding-block: 2px;
}

  .w_6px {
    width: 6px;
}

  .h_6px {
    height: 6px;
}

  .rounded_50\% {
    border-radius: 50%;
}

  .gap_16 {
    gap: 16px;
}

  .text_colors\.purple-1 {
    color: colors.purple-1;
}

  .max-w_maxContainer {
    max-width: var(--sizes-max-container);
}

  .mx_auto {
    margin-inline: auto;
}

  .shadow_headerShadow {
    box-shadow: var(--shadows-header-shadow);
}

  .h_66px {
    height: 66px;
}

  .w_15\% {
    width: 15%;
}

  .w_80\% {
    width: 80%;
}

  .text_center {
    text-align: center;
}

  .pos_fixed {
    position: fixed;
}

  .z_layout {
    z-index: var(--z-index-layout);
}

  .w_90\% {
    width: 90%;
}

  .py_10px {
    padding-block: 10px;
}

  .w_\[100\%\] {
    width: 100%;
}

  .z_modal {
    z-index: var(--z-index-modal);
}

  .px_4px {
    padding-inline: 4px;
}

  .bg_white {
    background: var(--colors-white);
}

  .white-space_nowrap {
    white-space: nowrap;
}

  .text_purple-primary {
    color: var(--colors-purple-primary);
}

  .flex_1 {
    flex: 1 1 0%;
}

  .w_25\% {
    width: 25%;
}

  .h_66 {
    height: 66px;
}

  .p_16 {
    padding: 16px;
}

  .rounded_8 {
    border-radius: 8px;
}

  .border-b_1px_dashed {
    border-bottom: 1px dashed;
}

  .gap_8 {
    gap: 8px;
}

  .border-l_1px_solid {
    border-left: 1px solid;
}

  .h_17px {
    height: 17px;
}

  .text_red-1 {
    color: var(--colors-red-1);
}

  .overflow_hidden {
    overflow: hidden;
}

  .text_ellipsis {
    text-overflow: ellipsis;
}

  .w_26 {
    width: 26px;
}

  .h_26 {
    height: 26px;
}

  .gap_4 {
    gap: 4px;
}

  .max-w_160 {
    max-width: 160px;
}

  .border_1px_solid {
    border: 1px solid;
}

  .text_wrap {
    text-wrap: wrap;
}

  .max-w_150px {
    max-width: 150px;
}

  .z_camera {
    z-index: var(--z-index-camera);
}

  .backdrop-opacity_80 {
    --backdrop-opacity: 80;
}

  .h_120px {
    height: 120px;
}

  .row-span_span_1 {
    grid-row: span 1;
}

  .h_112px {
    height: 112px;
}

  .h_40px {
    height: 40px;
}

  .border-t_1px_solid {
    border-top: 1px solid;
}

  .w_60 {
    width: 60px;
}

  .h_60 {
    height: 60px;
}

  .d_none {
    display: none;
}

  .w_95\% {
    width: 95%;
}

  .text_black-2 {
    color: var(--colors-black-2);
}

  .max-h_400px {
    max-height: 400px;
}

  .my_20px {
    margin-block: 20px;
}

  .stroke_black-2 {
    stroke: var(--colors-black-2);
}

  .stroke_purple-3 {
    stroke: var(--colors-purple-3);
}

  .gap_10px {
    gap: 10px;
}

  .p_0 {
    padding: 0;
}

  .h_initial {
    height: initial;
}

  .text_purple-2 {
    color: var(--colors-purple-2);
}

  .h_95dvh {
    height: 95dvh;
}

  .py_20px {
    padding-block: 20px;
}

  .w_60px {
    width: 60px;
}

  .w_auto\! {
    width: auto !important;
}

  .rounded_16px {
    border-radius: 16px;
}

  .w_62px {
    width: 62px;
}

  .text_success {
    color: success;
}

  .my_15px {
    margin-block: 15px;
}

  .my_2rem {
    margin-block: 2rem;
}

  .my_1rem {
    margin-block: 1rem;
}

  .text_orange {
    color: var(--colors-orange);
}

  .p_15px {
    padding: 15px;
}

  .h_1px {
    height: 1px;
}

  .border-b_1px_solid_\{colors\.gray-2\} {
    border-bottom: 1px solid var(--colors-gray-2);
}

  .scrollbar_hidden {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

  .scrollbar_hidden::-webkit-scrollbar {
    display: none;
}

  .w_50\% {
    width: 50%;
}

  .w_8px {
    width: 8px;
}

  .h_8px {
    height: 8px;
}

  .rounded_3px {
    border-radius: 3px;
}

  .w_45\% {
    width: 45%;
}

  .text_green {
    color: var(--colors-green);
}

  .w_48px {
    width: 48px;
}

  .h_48px {
    height: 48px;
}

  .w_40px {
    width: 40px;
}

  .gap_2rem {
    gap: 2rem;
}

  .gap_\.5rem {
    gap: .5rem;
}

  .py_5px {
    padding-block: 5px;
}

  .mx_1rem {
    margin-inline: 1rem;
}

  .text_white {
    color: var(--colors-white);
}

  .h_64px {
    height: 64px;
}

  .rounded_12px {
    border-radius: 12px;
}

  .px_16px {
    padding-inline: 16px;
}

  .bg_linear-gradient\(90deg\,_rgba\(99\,_45\,_246\,_1\)_0\%\,_rgba\(152\,_114\,_255\,_1\)_100\%\) {
    background: linear-gradient(90deg, rgba(99, 45, 246, 1) 0%, rgba(152, 114, 255, 1) 100%);
}

  .shadow_0px_2px_10px_0px_rgba\(191\,_191\,_191\,_0\.1\) {
    box-shadow: 0px 2px 10px 0px rgba(191, 191, 191, 0.1);
}

  .gap_6 {
    gap: 6px;
}

  .h_24px {
    height: 24px;
}

  .w_24px {
    width: 24px;
}

  .overscroll_none {
    overscroll-behavior: none;
}

  .gap_24 {
    gap: 24px;
}

  .pos_sticky {
    position: sticky;
}

  .z_1 {
    z-index: 1;
}

  .gap_12 {
    gap: 12px;
}

  .rounded_24 {
    border-radius: 24px;
}

  .rounded-ee_0 {
    border-end-end-radius: 0;
}

  .rounded-es_0 {
    border-end-start-radius: 0;
}

  .p_24 {
    padding: 24px;
}

  .w_10 {
    width: 10px;
}

  .h_10 {
    height: 10px;
}

  .rounded_50 {
    border-radius: 50px;
}

  .max-w_80\% {
    max-width: 80%;
}

  .max-w_100\% {
    max-width: 100%;
}

  .max-w_224px {
    max-width: 224px;
}

  .min-w_224px {
    min-width: 224px;
}

  .min-w_280px {
    min-width: 280px;
}

  .border_1px_solid_\#EBEBEB {
    border: 1px solid #EBEBEB;
}

  .rounded_16 {
    border-radius: 16px;
}

  .rounded-t_16 {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

  .p_12 {
    padding: 12px;
}

  .transition_all_0\.2s_ease-in-out {
    transition: all 0.2s ease-in-out;
}

  .h_126px {
    height: 126px;
}

  .h_180px {
    height: 180px;
}

  .object_cover {
    object-fit: cover;
}

  .object_contain {
    object-fit: contain;
}

  .clamp_1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

  .direction_rtl {
    direction: rtl;
}

  .px_2 {
    padding-inline: 2px;
}

  .px_4 {
    padding-inline: 4px;
}

  .py_2 {
    padding-block: 2px;
}

  .text_black {
    color: var(--colors-black);
}

  .px_6 {
    padding-inline: 6px;
}

  .py_1 {
    padding-block: 1px;
}

  .py_32 {
    padding-block: 32px;
}

  .h_40vh {
    height: 40vh;
}

  .p_24px_0px {
    padding: 24px 0px;
}

  .gap_10 {
    gap: 10px;
}

  .p_15px_0px {
    padding: 15px 0px;
}

  .p_24px {
    padding: 24px;
}

  .transform_translate\(-50\%\,-50\%\) {
    transform: translate(-50%,-50%);
}

  .border_2px_solid_white {
    border: 2px solid white;
}

  .my_30px {
    margin-block: 30px;
}

  .py_10 {
    padding-block: 10px;
}

  .gap_4px {
    gap: 4px;
}

  .flex_unset {
    flex: unset;
}

  .min-w_146 {
    min-width: 146px;
}

  .p_4 {
    padding: 4px;
}

  .gap_5 {
    gap: 5px;
}

  .w_14 {
    width: 14px;
}

  .h_14 {
    height: 14px;
}

  .d_grid {
    display: grid;
}

  .px_1rem {
    padding-inline: 1rem;
}

  .\--thickness_1px {
    --thickness: 1px;
}

  .p_2px_0px {
    padding: 2px 0px;
}

  .h_4 {
    height: 4px;
}

  .m_32px_0px {
    margin: 32px 0px;
}

  .p_7px_16px {
    padding: 7px 16px;
}

  .w_20 {
    width: 20px;
}

  .h_20 {
    height: 20px;
}

  .border-t_1px_solid_\{colors\.gray-2\} {
    border-top: 1px solid var(--colors-gray-2);
}

  .text_right {
    text-align: right;
}

  .text_left {
    text-align: left;
}

  .h_300 {
    height: 300px;
}

  .px_10 {
    padding-inline: 10px;
}

  .border-b_1px_solid_\#F0F0F0 {
    border-bottom: 1px solid #F0F0F0;
}

  .text_common {
    color: common;
}

  .scrollbar-width_none {
    scrollbar-width: none;
}

  .bg_purple-6 {
    background: var(--colors-purple-6);
}

  .min-w_70 {
    min-width: 70px;
}

  .min-h_24 {
    min-height: 24px;
}

  .h_400 {
    height: 400px;
}

  .border_1px_dashed {
    border: 1px dashed;
}

  .overflow_auto {
    overflow: auto;
}

  .bg_green-4 {
    background: var(--colors-green-4);
}

  .px_8 {
    padding-inline: 8px;
}

  .bg_yellow-1 {
    background: var(--colors-yellow-1);
}

  .text_purple-1 {
    color: var(--colors-purple-1);
}

  .text_yellow {
    color: var(--colors-yellow);
}

  .min-h_30vh {
    min-height: 30vh;
}

  .max-h_45vh {
    max-height: 45vh;
}

  .px_12 {
    padding-inline: 12px;
}

  .py_8 {
    padding-block: 8px;
}

  .bg_gray-3 {
    background: var(--colors-gray-3);
}

  .w_calc\(50\%_-_8px\) {
    width: calc(50% - 8px);
}

  .text_justify {
    text-align: justify;
}

  .w_16 {
    width: 16px;
}

  .p_12px_16px {
    padding: 12px 16px;
}

  .text_red {
    color: var(--colors-red);
}

  .px_15px {
    padding-inline: 15px;
}

  .h_30px {
    height: 30px;
}

  .text_green-2 {
    color: var(--colors-green-2);
}

  .w_30 {
    width: 30px;
}

  .d_inline-flex {
    display: inline-flex;
}

  .gap_0\.5rem {
    gap: 0.5rem;
}

  .mx_4px {
    margin-inline: 4px;
}

  .flex_0_0_auto {
    flex: 0 0 auto;
}

  .rounded_9999px {
    border-radius: 9999px;
}

  .border_none {
    border: none;
}

  .stroke_purple-primary {
    stroke: var(--colors-purple-primary);
}

  .stroke_blue {
    stroke: var(--colors-blue);
}

  .stroke_orange {
    stroke: var(--colors-orange);
}

  .stroke_green {
    stroke: var(--colors-green);
}

  .stroke_pink {
    stroke: var(--colors-pink);
}

  .text_blue {
    color: var(--colors-blue);
}

  .text_purple-3 {
    color: var(--colors-purple-3);
}

  .text_green-1 {
    color: var(--colors-green-1);
}

  .text_pink {
    color: var(--colors-pink);
}

  .p_0\.1rem_1rem {
    padding: 0.1rem 1rem;
}

  .w_fit-content {
    width: fit-content;
}

  .gap_17px {
    gap: 17px;
}

  .p_16px {
    padding: 16px;
}

  .shadow_0px_0px_10px_0px_rgba\(0\,_0\,_0\,_0\.10\) {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
}

  .stroke-w_20px {
    stroke-width: 20px;
}

  .text_black-4 {
    color: var(--colors-black-4);
}

  .gap_2px {
    gap: 2px;
}

  .zoom_15 {
    zoom: 15;
}

  .overflow_clip {
    overflow: clip;
}

  .w_2\.5px {
    width: 2.5px;
}

  .p_12px {
    padding: 12px;
}

  .m_-12px {
    margin: -12px;
}

  .w_85\% {
    width: 85%;
}

  .z_9999 {
    z-index: 9999;
}

  .min-h_100px {
    min-height: 100px;
}

  .max-h_90dvh {
    max-height: 90dvh;
}

  .overscroll_contain {
    overscroll-behavior: contain;
}

  .rounded_30px_30px_0_0 {
    border-radius: 30px 30px 0 0;
}

  .transition_all_\.3s {
    transition: all .3s;
}

  .transform_translateY\(0\) {
    transform: translateY(0);
}

  .transform_translateY\(100\%\) {
    transform: translateY(100%);
}

  .min-h_90dvh {
    min-height: 90dvh;
}

  .transition_all_\.4s {
    transition: all .4s;
}

  .opacity_0 {
    opacity: 0;
}

  .opacity_1 {
    opacity: 1;
}

  .py_12 {
    padding-block: 12px;
}

  .w_24 {
    width: 24px;
}

  .h_24 {
    height: 24px;
}

  .transition_width_0\.3s_ease {
    transition: width 0.3s ease;
}

  .max-w_3 {
    max-width: 3px;
}

  .min-w_1 {
    min-width: 1px;
}

  .gap_0 {
    gap: 0;
}

  .shadow_2px_2px_2px_2px_\#BFBFBF1A {
    box-shadow: 2px 2px 2px 2px #BFBFBF1A;
}

  .bg_\#e5e7eb {
    background: #e5e7eb;
}

  .inset_0 {
    inset: 0;
}

  .bg_linear-gradient\(90deg\,_transparent\,_rgba\(165\,_165\,_165\,_0\.6\)\,_transparent\) {
    background: linear-gradient(90deg, transparent, rgba(165, 165, 165, 0.6), transparent);
}

  .animation_skeleton-loading_1\.5s_infinite_linear {
    animation: skeleton-loading 1.5s infinite linear;
}

  .zoom_true {
    zoom: true;
}

  .z_toast {
    z-index: var(--z-index-toast);
}

  .w_20px {
    width: 20px;
}

  .h_20px {
    height: 20px;
}

  .stroke_red {
    stroke: var(--colors-red);
}

  .stroke_green-2 {
    stroke: var(--colors-green-2);
}

  .p_5px {
    padding: 5px;
}

  .w_25px {
    width: 25px;
}

  .h_25px {
    height: 25px;
}

  .w_5px {
    width: 5px;
}

  .h_5px {
    height: 5px;
}

  .w_3px {
    width: 3px;
}

  .touch_none {
    touch-action: none;
}

  .overscroll-y_contain {
    overscroll-behavior-y: contain;
}

  .h_100lvh {
    height: 100lvh;
}

  .transform_translate\(-50\%\,_-50\%\) {
    transform: translate(-50%, -50%);
}

  .backdrop_blur\(12px\) {
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
}

  .w_120px {
    width: 120px;
}

  .transform_translate\(-50\%\,_-50\%\)_rotate\(90deg\) {
    transform: translate(-50%, -50%) rotate(90deg);
}

  .w_30px {
    width: 30px;
}

  .z_camera-layout {
    z-index: var(--z-index-camera-layout);
}

  .h_10\% {
    height: 10%;
}

  .rounded_24px_24px_0_0 {
    border-radius: 24px 24px 0 0;
}

  .flex_5 {
    flex: 5;
}

  .gap_5rem {
    gap: 5rem;
}

  .fill_\#c2c2c2 {
    fill: #c2c2c2;
}

  .fill_\#fff {
    fill: #fff;
}

  .h_auto {
    height: auto;
}

  .rounded_8px_8px_0_0 {
    border-radius: 8px 8px 0 0;
}

  .h_420px {
    height: 420px;
}

  .select_none {
    -webkit-user-select: none;
    user-select: none;
}

  .gap_24px {
    gap: 24px;
}

  .p_0\.5rem {
    padding: 0.5rem;
}

  .w_50px {
    width: 50px;
}

  .h_50px {
    height: 50px;
}

  .h_152px {
    height: 152px;
}

  .h_300px {
    height: 300px;
}

  .shadow_0px_4px_8px_0px_\#BFBFBF1A {
    box-shadow: 0px 4px 8px 0px #BFBFBF1A;
}

  .gap_2 {
    gap: 2px;
}

  .w_160px {
    width: 160px;
}

  .text_danger {
    color: danger;
}

  .text_inherit {
    color: inherit;
}

  .h_16 {
    height: 16px;
}

  .p_0_1rem {
    padding: 0 1rem;
}

  .transform_translateY\(-1\.5rem\) {
    transform: translateY(-1.5rem);
}

  .border_1px_solid_\{colors\.gray-3\} {
    border: 1px solid var(--colors-gray-3);
}

  .h_36 {
    height: 36px;
}

  .text_\#465c73 {
    color: #465c73;
}

  .h_32 {
    height: 32px;
}

  .shadow_0px_1px_4px_0px_\#ddd8ff {
    box-shadow: 0px 1px 4px 0px #ddd8ff;
}

  .snap_x_mandatory {
    scroll-snap-type: x mandatory;
}

  .cursor_default {
    cursor: default;
}

  .flex_0_0_calc\(\(100\%_-_36px\)_\/_4\) {
    flex: 0 0 calc((100% - 36px) / 4);
}

  .snap_start {
    scroll-snap-align: start;
}

  .text_\#8e68f6 {
    color: #8e68f6;
}

  .flex_1_0_0 {
    flex: 1 0 0;
}

  .h_1 {
    height: 1px;
}

  .bg_radial-gradient\(circle_at_20\%_50\%\,_rgba\(255\,_255\,_255\,_0\.1\)_0\%\,_transparent_40\%\)\,_radial-gradient\(circle_at_35\%_50\%\,_rgba\(255\,_255\,_255\,_0\.05\)_0\%\,_transparent_60\%\)\,_linear-gradient\(135deg\,_\#5e54b6_0\%\,_\#3e3682_100\%\) {
    background: radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 40%), radial-gradient(circle at 35% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 60%), linear-gradient(135deg, #5e54b6 0%, #3e3682 100%);
}

  .text_gray-3 {
    color: var(--colors-gray-3);
}

  .text_gray-2 {
    color: var(--colors-gray-2);
}

  .w_80px {
    width: 80px;
}

  .my_16px {
    margin-block: 16px;
}

  .w_110px {
    width: 110px;
}

  .w_56px {
    width: 56px;
}

  .h_311px {
    height: 311px;
}

  .max-h_60vh {
    max-height: 60vh;
}

  .gap_12px {
    gap: 12px;
}

  .border-b_1px_solid_\{colors\.gray-3\} {
    border-bottom: 1px solid var(--colors-gray-3);
}

  .h_10px {
    height: 10px;
}

  .w_10px {
    width: 10px;
}

  .text_grey {
    color: grey;
}

  .max-w_300px {
    max-width: 300px;
}

  .mx_20px {
    margin-inline: 20px;
}

  .py_4 {
    padding-block: 4px;
}

  .filter_drop-shadow\(0px_4px_4px_rgba\(191\,191\,191\,0\.1\)\) {
    filter: drop-shadow(0px 4px 4px rgba(191,191,191,0.1));
}

  .py_24px {
    padding-block: 24px;
}

  .max-h_70vh {
    max-height: 70vh;
}

  .my_34 {
    margin-block: 34px;
}

  .border_1px_solid_\{colors\.blue\} {
    border: 1px solid var(--colors-blue);
}

  .px_9 {
    padding-inline: 9px;
}

  .text_\#1c1c1c {
    color: #1c1c1c;
}

  .pointer-events_none {
    pointer-events: none;
}

  .z_2 {
    z-index: 2;
}

  .h_calc\(100\%_-_1px\) {
    height: calc(100% - 1px);
}

  .rounded-t_24px {
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
}

  .shadow_0_-16px_12px_rgba\(0\,0\,0\,0\.04\) {
    box-shadow: 0 -16px 12px rgba(0,0,0,0.04);
}

  .pointer-events_auto {
    pointer-events: auto;
}

  .transition_transform_0\.1s_linear {
    transition: transform 0.1s linear;
}

  .will-change_transform {
    will-change: transform;
}

  .w_32px {
    width: 32px;
}

  .h_4px {
    height: 4px;
}

  .bg_\#D1D1D1 {
    background: #D1D1D1;
}

  .px_16 {
    padding-inline: 16px;
}

  .p_8 {
    padding: 8px;
}

  .m_-8 {
    margin: -8px;
}

  .bg_linear-gradient\(107deg\,_\#7548F0_13\.872\%\,_\#43298A_87\.202\%\) {
    background: linear-gradient(107deg, #7548F0 13.872%, #43298A 87.202%);
}

  .h_170 {
    height: 170px;
}

  .w_232 {
    width: 232px;
}

  .h_214 {
    height: 214px;
}

  .opacity_0\.5 {
    opacity: 0.5;
}

  .transform_scaleX\(-1\)_rotate\(10\.23deg\) {
    transform: scaleX(-1) rotate(10.23deg);
}

  .transform_rotate\(180deg\) {
    transform: rotate(180deg);
}

  .px_14 {
    padding-inline: 14px;
}

  .text_\#485D73 {
    color: #485D73;
}

  .text_\#0A66C2 {
    color: #0A66C2;
}

  .text_\#009155 {
    color: #009155;
}

  .w_2px {
    width: 2px;
}

  .h_18px {
    height: 18px;
}

  .mx_8 {
    margin-inline: 8px;
}

  .h_246px {
    height: 246px;
}

  .h_270px {
    height: 270px;
}

  .bg_\#715CAC6B {
    background: #715CAC6B;
}

  .rounded_full {
    border-radius: full;
}

  .ring_none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}

  .m_0 {
    margin: 0;
}

  .transition_transform_0\.2s {
    transition: transform 0.2s;
}

  .p_12px_14px {
    padding: 12px 14px;
}

  .min-h_6px {
    min-height: 6px;
}

  .rounded_rounded {
    border-radius: var(--radii-rounded);
}

  .transition_background-color_\.2s {
    transition: background-color .2s;
}

  .min-w_48px {
    min-width: 48px;
}

  .text_\#FFF {
    color: #FFF;
}

  .w_calc\(\(100\%_-_32px\)_\/_3\) {
    width: calc((100% - 32px) / 3);
}

  .w_50 {
    width: 50px;
}

  .h_50 {
    height: 50px;
}

  .h_30vh {
    height: 30vh;
}

  .bg_gray-4 {
    background: var(--colors-gray-4);
}

  .h_15px {
    height: 15px;
}

  .bg_purple-4 {
    background: var(--colors-purple-4);
}

  .mx_2 {
    margin-inline: 2px;
}

  .h_60vh {
    height: 60vh;
}

  .p_2 {
    padding: 2px;
}

  .my_32px {
    margin-block: 32px;
}

  .h_80vh {
    height: 80vh;
}

  .gap_3 {
    gap: 3px;
}

  .text_colors\.purple-3 {
    color: colors.purple-3;
}

  .px_20px {
    padding-inline: 20px;
}

  .py_8px {
    padding-block: 8px;
}

  .border-b_2px_dashed_\{colors\.gray-2\} {
    border-bottom: 2px dashed var(--colors-gray-2);
}

  .text_purpleLight {
    color: purpleLight;
}

  .p_10px_15px {
    padding: 10px 15px;
}

  .h_60px {
    height: 60px;
}

  .border-l_1px_solid_\{colors\.gray-2\} {
    border-left: 1px solid var(--colors-gray-2);
}

  .m_5px_0px {
    margin: 5px 0px;
}

  .p_1px {
    padding: 1px;
}

  .shadow_0px_4px_8px_0px_rgba\(0\,_0\,_0\,_0\.04\) {
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
}

  .p_12px_12px {
    padding: 12px 12px;
}

  .rounded_7px {
    border-radius: 7px;
}

  .text_\#374151 {
    color: #374151;
}

  .text_\#646464 {
    color: #646464;
}

  .w_300px {
    width: 300px;
}

  .h_140px {
    height: 140px;
}

  .w_281px {
    width: 281px;
}

  .h_281px {
    height: 281px;
}

  .bg_conic-gradient\(_from_270deg\,_\#ff5f5f_0deg\,_\#ffbd47_45deg\,_\#ffff54_90deg\,_\#a3e635_135deg\,_\#22c55e_180deg_\) {
    background: conic-gradient( from 270deg, #ff5f5f 0deg, #ffbd47 45deg, #ffff54 90deg, #a3e635 135deg, #22c55e 180deg );
}

  .\-webkit-mask-image_radial-gradient\(farthest-side\,_transparent_75\%\,_white_76\%\) {
    -webkit-mask-image: radial-gradient(farthest-side, transparent 75%, white 76%);
}

  .h_35\% {
    height: 35%;
}

  .bg_black {
    background: var(--colors-black);
}

  .rounded_281px {
    border-radius: 281px;
}

  .text_\#fff {
    color: #fff;
}

  .text_\#00A661 {
    color: #00A661;
}

  .p_6px {
    padding: 6px;
}

  .min-w_max-content {
    min-width: max-content;
}

  .min-h_40px {
    min-height: 40px;
}

  .p_0_8px {
    padding: 0 8px;
}

  .transition_all_0\.2s_ease {
    transition: all 0.2s ease;
}

  .p_24px_16px {
    padding: 24px 16px;
}

  .w_4px {
    width: 4px;
}

  .h_22px {
    height: 22px;
}

  .max-w_400px {
    max-width: 400px;
}

  .white-space_pre-line {
    white-space: pre-line;
}

  .h_14vh {
    height: 14vh;
}

  .bg_\#277A9D {
    background: #277A9D;
}

  .bg_purple-primary {
    background: var(--colors-purple-primary);
}

  .py_4px {
    padding-block: 4px;
}

  .px_8px {
    padding-inline: 8px;
}

  .rounded_999px {
    border-radius: 999px;
}

  .text_\#277A9D {
    color: #277A9D;
}

  .transform_translateX\(-50\%\) {
    transform: translateX(-50%);
}

  .w_max-content {
    width: max-content;
}

  .max-w_min\(280px\,_calc\(100vw_-_32px\)\) {
    max-width: min(280px, calc(100vw - 32px));
}

  .z_100 {
    z-index: 100;
}

  .shadow_0_4px_12px_rgba\(0\,_0\,_0\,_0\.3\) {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

  .animation_fadeInTooltip_0\.2s_ease-out_forwards {
    animation: fadeInTooltip 0.2s ease-out forwards;
}

  .h_70px {
    height: 70px;
}

  .border-b_1px_solid {
    border-bottom: 1px solid;
}

  .py_16px {
    padding-block: 16px;
}

  .gap_20px {
    gap: 20px;
}

  .h_20vh {
    height: 20vh;
}

  .p_8px_16px {
    padding: 8px 16px;
}

  .shadow_0_10px_15px_-10px_rgba\(0\,_0\,_0\,_0\.04\) {
    box-shadow: 0 10px 15px -10px rgba(0, 0, 0, 0.04);
}

  .w_calc\(100\%_\+_32px\) {
    width: calc(100% + 32px);
}

  .mx_-16px {
    margin-inline: -16px;
}

  .bg_transparent {
    background: transparent;
}

  .transition_all_0\.2s {
    transition: all 0.2s;
}

  .p_8px_0px {
    padding: 8px 0px;
}

  .m_10px_0px {
    margin: 10px 0px;
}

  .text_\#303030 {
    color: #303030;
}

  .gap_35px {
    gap: 35px;
}

  .m_20px_0px {
    margin: 20px 0px;
}

  .bg_purpleLinear {
    background: var(--colors-purple-linear);
}

  .w_40 {
    width: 40px;
}

  .h_40 {
    height: 40px;
}

  .p_8px {
    padding: 8px;
}

  .p_10 {
    padding: 10px;
}

  .my_1\.5rem {
    margin-block: 1.5rem;
}

  .mx_10px {
    margin-inline: 10px;
}

  .max-w_112 {
    max-width: 112px;
}

  .w_8 {
    width: 8px;
}

  .h_8 {
    height: 8px;
}

  .text_start {
    text-align: start;
}

  .caret_purple-primary {
    caret-color: var(--colors-purple-primary);
}

  .min-h_48px {
    min-height: 48px;
}

  .ps_48px {
    padding-inline-start: 48px;
}

  .ps_70px {
    padding-inline-start: 70px;
}

  .ps_100px {
    padding-inline-start: 100px;
}

  .pe_48px {
    padding-inline-end: 48px;
}

  .pe_70px {
    padding-inline-end: 70px;
}

  .pe_100px {
    padding-inline-end: 100px;
}

  .start_0 {
    inset-inline-start: 0;
}

  .w_70px {
    width: 70px;
}

  .w_100px {
    width: 100px;
}

  .end_0 {
    inset-inline-end: 0;
}

  .w_22px {
    width: 22px;
}

  .translate_0_20px {
    translate: 0 20px;
}

  .w_11px {
    width: 11px;
}

  .direction_ltr {
    direction: ltr;
}

  .py_13px {
    padding-block: 13px;
}

  .border-b_1px_solid_\#f0f0f0 {
    border-bottom: 1px solid #f0f0f0;
}

  .max-h_50vh {
    max-height: 50vh;
}

  .text_\{colors\.black-3\} {
    color: var(--colors-black-3);
}

  .transition_border-color_0\.2s_ease-in-out {
    transition: border-color 0.2s ease-in-out;
}

  .w_32 {
    width: 32px;
}

  .w_66 {
    width: 66px;
}

  .z_1000 {
    z-index: 1000;
}

  .transform_translate\(-20\%\,-20\%\) {
    transform: translate(-20%,-20%);
}

  .p_4px {
    padding: 4px;
}

  .z_map-extension {
    z-index: var(--z-index-map-extension);
}

  .transform_translate\(-50\%\,-90\%\) {
    transform: translate(-50%,-90%);
}

  .px_1\.2rem {
    padding-inline: 1.2rem;
}

  .h_calc\(100\%_-_40px\) {
    height: calc(100% - 40px);
}

  .rounded-b_8px {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

  .h_calc\(100dvh_-_80px\) {
    height: calc(100dvh - 80px);
}

  .transform_rotate\(90deg\) {
    transform: rotate(90deg);
}

  .min-w_300px {
    min-width: 300px;
}

  .flex_6 {
    flex: 6;
}

  .flex_4 {
    flex: 4;
}

  .mx_24 {
    margin-inline: 24px;
}

  .flex_1\.5 {
    flex: 1.5;
}

  .gap_3rem {
    gap: 3rem;
}

  .p_0\.5rem_1rem {
    padding: 0.5rem 1rem;
}

  .stroke_\#c2c2c2 {
    stroke: #c2c2c2;
}

  .stroke_\#7548F0 {
    stroke: #7548F0;
}

  .w_100vw {
    width: 100vw;
}

  .h_100vh {
    height: 100vh;
}

  .max-h_70\% {
    max-height: 70%;
}

  .px_2rem {
    padding-inline: 2rem;
}

  .bg_rgba\(0\,0\,0\,0\.15\) {
    background: rgba(0,0,0,0.15);
}

  .h_56px {
    height: 56px;
}

  .py_12px {
    padding-block: 12px;
}

  .p_12px_44px {
    padding: 12px 44px;
}

  .bg_delayLinear {
    background: var(--colors-delay-linear);
}

  .bg_purple-7 {
    background: var(--colors-purple-7);
}

  .max-h_80vh {
    max-height: 80vh;
}

  .h_600px {
    height: 600px;
}

  .h_350px {
    height: 350px;
}

  .border_1px_solid_\{colors\.orange-1\} {
    border: 1px solid var(--colors-orange-1);
}

  .mx_14 {
    margin-inline: 14px;
}

  .py_6 {
    padding-block: 6px;
}

  .border-b_1px {
    border-bottom: 1px;
}

  .pe_7 {
    padding-inline-end: 7px;
}

  .gap_32px {
    gap: 32px;
}

  .gap_65px {
    gap: 65px;
}

  .px_45px {
    padding-inline: 45px;
}

  .w_36 {
    width: 36px;
}

  .w_28 {
    width: 28px;
}

  .h_28 {
    height: 28px;
}

  .h_2 {
    height: 2px;
}

  .mx_5 {
    margin-inline: 5px;
}

  .transform_translateX\(-80\%\) {
    transform: translateX(-80%);
}

  .flex_none {
    flex: none;
}

  .h_48 {
    height: 48px;
}

  .w_144 {
    width: 144px;
}

  .\-webkit-overflow-scrolling_touch {
    -webkit-overflow-scrolling: touch;
}

  .w_47 {
    width: 47px;
}

  .text_purple {
    color: purple;
}

  .py_5 {
    padding-block: 5px;
}

  .rounded_4 {
    border-radius: 4px;
}

  .p_19 {
    padding: 19px;
}

  .flex_2 {
    flex: 2;
}

  .px_18 {
    padding-inline: 18px;
}

  .bg_orange-3 {
    background: var(--colors-orange-3);
}

  .w_42px {
    width: 42px;
}

  .h_42px {
    height: 42px;
}

  .gap_32 {
    gap: 32px;
}

  .max-h_40vh {
    max-height: 40vh;
}

  .border-b_1px_solid_\#E1E1E1 {
    border-bottom: 1px solid #E1E1E1;
}

  .border_2px_solid_\#F0EEFF {
    border: 2px solid #F0EEFF;
}

  .px_17px {
    padding-inline: 17px;
}

  .gap_0\.25rem {
    gap: 0.25rem;
}

  .rounded_34px {
    border-radius: 34px;
}

  .w_60\% {
    width: 60%;
}

  .stroke_currentColor {
    stroke: currentColor;
}

  .border_1px_solid_\#c2c2c2 {
    border: 1px solid #c2c2c2;
}

  .text_GrayText {
    color: GrayText;
}

  .w_80 {
    width: 80px;
}

  .px_30px {
    padding-inline: 30px;
}

  .h_38px {
    height: 38px;
}

  .min-h_initial {
    min-height: initial;
}

  .text_center\! {
    text-align: center !important;
}

  .w_70\% {
    width: 70%;
}

  .w_75\% {
    width: 75%;
}

  .border-r_2px_solid_\{colors\.gray-1\} {
    border-right: 2px solid var(--colors-gray-1);
}

  .w_initial {
    width: initial;
}

  .flex_3 {
    flex: 3;
}

  .border-r_1px_solid {
    border-right: 1px solid;
}

  .w_1px {
    width: 1px;
}

  .h_2\.2rem {
    height: 2.2rem;
}

  .w_65\% {
    width: 65%;
}

  .rounded_8px_0_0_8px {
    border-radius: 8px 0 0 8px;
}

  .border_0px {
    border: 0px;
}

  .min-h_32px {
    min-height: 32px;
}

  .flex_13 {
    flex: 13;
}

  .min-w_50px {
    min-width: 50px;
}

  .min-w_70px {
    min-width: 70px;
}

  .gap_2em {
    gap: 2em;
}

  .my_3rem {
    margin-block: 3rem;
}

  .min-w_20px {
    min-width: 20px;
}

  .bg_purple-3 {
    background: var(--colors-purple-3);
}

  .rounded_12px_12px_0_0 {
    border-radius: 12px 12px 0 0;
}

  .rounded_0_0_12px_12px {
    border-radius: 0 0 12px 12px;
}

  .gap_1 {
    gap: 1px;
}

  .h_210px {
    height: 210px;
}

  .bg_linear-gradient\(to_bottom\,_white_0\%\,_transparent_100\%\) {
    background: linear-gradient(to bottom, white 0%, transparent 100%);
}

  .z_10 {
    z-index: 10;
}

  .bg_linear-gradient\(to_top\,_white_0\%\,_transparent_100\%\) {
    background: linear-gradient(to top, white 0%, transparent 100%);
}

  .transform_scale\(1\.1\) {
    transform: scale(1.1);
}

  .bg_\#0042AD {
    background: #0042AD;
}

  .rounded-l_4px {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

  .border-r_none {
    border-right: none;
}

  .w_15px {
    width: 15px;
}

  .gap_3px {
    gap: 3px;
}

  .px_3px {
    padding-inline: 3px;
}

  .border-l_none {
    border-left: none;
}

  .rounded-r_4px {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

  .w_7px {
    width: 7px;
}

  .px_5px {
    padding-inline: 5px;
}

  .bg_black-5 {
    background: var(--colors-black-5);
}

  .w_250px {
    width: 250px;
}

  .h_400px {
    height: 400px;
}

  .rotate_90deg {
    rotate: 90deg;
}

  .min-w_150px {
    min-width: 150px;
}

  .my_25px {
    margin-block: 25px;
}

  .py_24 {
    padding-block: 24px;
}

  .gap_79 {
    gap: 79px;
}

  .gap_40 {
    gap: 40px;
}

  .gap_37px {
    gap: 37px;
}

  .px_35px {
    padding-inline: 35px;
}

  .mx_16 {
    margin-inline: 16px;
}

  .my_24px {
    margin-block: 24px;
}

  .bg_pink-2 {
    background: var(--colors-pink-2);
}

  .mx_12 {
    margin-inline: 12px;
}

  .p_0\.5rem_1\.5rem {
    padding: 0.5rem 1.5rem;
}

  .bg-gradient_to-r {
    --gradient-stops: var(--gradient-from), var(--gradient-to);
    --gradient: var(--gradient-via-stops, var(--gradient-stops));
    background-image: linear-gradient(to right, var(--gradient));
}

  .from_\#F1F0F8 {
    --gradient-from: #F1F0F8;
}

  .to_transparent {
    --gradient-to: transparent;
}

  .rounded_33px {
    border-radius: 33px;
}

  .p_2px_8px {
    padding: 2px 8px;
}

  .h_75dvh {
    height: 75dvh;
}

  .transition_all_0\.7s_ease-out {
    transition: all 0.7s ease-out;
}

  .h_9rem {
    height: 9rem;
}

  .border_2px_solid {
    border: 2px solid;
}

  .h_75px {
    height: 75px;
}

  .w_105px {
    width: 105px;
}

  .text_initial {
    color: initial;
}

  .w_75px {
    width: 75px;
}

  .h_105px {
    height: 105px;
}

  .border-b_1px_solid_\{colors\.gray-1\} {
    border-bottom: 1px solid var(--colors-gray-1);
}

  .text_color\.black {
    color: color.black;
}

  .min-w_12px {
    min-width: 12px;
}

  .border-r_1px_solid_\{colors\.gray-2\} {
    border-right: 1px solid var(--colors-gray-2);
}

  .py_16 {
    padding-block: 16px;
}

  .gap_30 {
    gap: 30px;
}

  .py_9 {
    padding-block: 9px;
}

  .rounded-l_0px {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

  .rounded-r_0px {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

  .max-w_176px {
    max-width: 176px;
}

  .h_42 {
    height: 42px;
}

  .w_42 {
    width: 42px;
}

  .text_red-3 {
    color: var(--colors-red-3);
}

  .p_0\.8rem {
    padding: 0.8rem;
}

  .from_\#E9FEF5 {
    --gradient-from: #E9FEF5;
}

  .h_750px {
    height: 750px;
}

  .border_1px_solid_\{colors\.gray-2\} {
    border: 1px solid var(--colors-gray-2);
}

  .border-r_1px_solid_\{colors\.gray-3\} {
    border-right: 1px solid var(--colors-gray-3);
}

  .p_14px {
    padding: 14px;
}

  .max-w_200px {
    max-width: 200px;
}

  .gap_0\.2rem {
    gap: 0.2rem;
}

  .overflow_scroll {
    overflow: scroll;
}

  .h_140 {
    height: 140px;
}

  .mx_6 {
    margin-inline: 6px;
}

  .my_10 {
    margin-block: 10px;
}

  .gap_23 {
    gap: 23px;
}

  .flex-wrap_wrap {
    flex-wrap: wrap;
}

  .mt_10px {
    margin-top: 10px;
}

  .justify_center {
    justify-content: center;
}

  .items_center {
    align-items: center;
}

  .flex_column {
    flex-direction: column;
}

  .justify_space-between {
    justify-content: space-between;
}

  .fs_1rem {
    font-size: 1rem;
}

  .bg_transparent {
    background-color: transparent;
}

  .top_0 {
    top: 0;
}

  .bottom_0 {
    bottom: 0;
}

  .right_0 {
    right: 0;
}

  .left_0 {
    left: 0;
}

  .bg_white {
    background-color: var(--colors-white);
}

  .fs_11px {
    font-size: 11px;
}

  .top_2px {
    top: 2px;
}

  .bg_\#FFF4CF {
    background-color: #FFF4CF;
}

  .shrink_1 {
    flex-shrink: 1;
}

  .font_bold {
    font-weight: var(--font-weights-bold);
}

  .pt_8px {
    padding-top: 8px;
}

  .bg_orange-3 {
    background-color: var(--colors-orange-3);
}

  .ml_5px {
    margin-left: 5px;
}

  .bg_orange {
    background-color: var(--colors-orange);
}

  .bg_blue-2 {
    background-color: var(--colors-blue-2);
}

  .bg_blue {
    background-color: var(--colors-blue);
}

  .bg_pink-2 {
    background-color: var(--colors-pink-2);
}

  .bg_pink {
    background-color: var(--colors-pink);
}

  .mt_4px {
    margin-top: 4px;
}

  .pb_24 {
    padding-bottom: 24px;
}

  .pb_initial {
    padding-bottom: initial;
}

  .mt_66px {
    margin-top: 66px;
}

  .mt_30px {
    margin-top: 30px;
}

  .top_5 {
    top: 5px;
}

  .bg_gray-4 {
    background-color: var(--colors-gray-4);
}

  .mb_1rem {
    margin-bottom: 1rem;
}

  .mb_1\.5rem {
    margin-bottom: 1.5rem;
}

  .mb_2rem {
    margin-bottom: 2rem;
}

  .mt_0\.5rem {
    margin-top: 0.5rem;
}

  .border_gray-3 {
    border-color: var(--colors-gray-3);
}

  .pb_8 {
    padding-bottom: 8px;
}

  .flex_row {
    flex-direction: row;
}

  .bg_green-4 {
    background-color: var(--colors-green-4);
}

  .mt_16 {
    margin-top: 16px;
}

  .bg_purple-3 {
    background-color: var(--colors-purple-3);
}

  .mt_48 {
    margin-top: 48px;
}

  .border_purple-3 {
    border-color: var(--colors-purple-3);
}

  .mb_20 {
    margin-bottom: 20px;
}

  .mt_18 {
    margin-top: 18px;
}

  .bg_black {
    background-color: var(--colors-black);
}

  .justify_space-around {
    justify-content: space-around;
}

  .bg_\#c2c2c2c8 {
    background-color: #c2c2c2c8;
}

  .justify_space-evenly {
    justify-content: space-evenly;
}

  .border_green-2 {
    border-color: var(--colors-green-2);
}

  .bg_purple-6 {
    background-color: var(--colors-purple-6);
}

  .border_purple-primary {
    border-color: var(--colors-purple-primary);
}

  .bg_\#BCBCBCCC {
    background-color: #BCBCBCCC;
}

  .justify_end {
    justify-content: end;
}

  .mt_20px {
    margin-top: 20px;
}

  .mb_12 {
    margin-bottom: 12px;
}

  .mb_24 {
    margin-bottom: 24px;
}

  .mt_24px,.mt_24 {
    margin-top: 24px;
}

  .overflow-y_auto {
    overflow-y: auto;
}

  .mb_25px {
    margin-bottom: 25px;
}

  .mt_80px {
    margin-top: 80px;
}

  .mb_10px {
    margin-bottom: 10px;
}

  .mt_1rem {
    margin-top: 1rem;
}

  .mt_33 {
    margin-top: 33px;
}

  .mt_2rem {
    margin-top: 2rem;
}

  .border_orange {
    border-color: var(--colors-orange);
}

  .mb_15px {
    margin-bottom: 15px;
}

  .mt_40px {
    margin-top: 40px;
}

  .pt_25px {
    padding-top: 25px;
}

  .mb_60 {
    margin-bottom: 60px;
}

  .mb_0 {
    margin-bottom: 0;
}

  .mb_20px {
    margin-bottom: 20px;
}

  .fs_12px {
    font-size: 12px;
}

  .flex_rtl {
    flex-direction: rtl;
}

  .pt_15px {
    padding-top: 15px;
}

  .mb_5px {
    margin-bottom: 5px;
}

  .pt_12 {
    padding-top: 12px;
}

  .fs_18 {
    font-size: 18px;
}

  .bg_gray-1 {
    background-color: var(--colors-gray-1);
}

  .bg_green-2 {
    background-color: var(--colors-green-2);
}

  .shrink_0 {
    flex-shrink: 0;
}

  .bottom_12 {
    bottom: 12px;
}

  .left_12 {
    left: 12px;
}

  .bg_\#00000080 {
    background-color: #00000080;
}

  .mb_4 {
    margin-bottom: 4px;
}

  .mb_8 {
    margin-bottom: 8px;
}

  .bg_gray-2 {
    background-color: var(--colors-gray-2);
}

  .overflow-x_auto {
    overflow-x: auto;
}

  .mb_40 {
    margin-bottom: 40px;
}

  .pt_54px {
    padding-top: 54px;
}

  .left_50\% {
    left: 50%;
}

  .mt_8px {
    margin-top: 8px;
}

  .bg_pink-1 {
    background-color: var(--colors-pink-1);
}

  .mt_90px {
    margin-top: 90px;
}

  .gap-x_14 {
    row-gap: 14px;
}

  .pt_20px {
    padding-top: 20px;
}

  .mt_32px {
    margin-top: 32px;
}

  .mb_16 {
    margin-bottom: 16px;
}

  .mb_5\.5rem {
    margin-bottom: 5.5rem;
}

  .grid-cols_repeat\(2\,_minmax\(0\,_1fr\)\) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

  .bottom_0px {
    bottom: 0px;
}

  .border-block-end-width_var\(--thickness\) {
    border-block-end-width: var(--thickness);
}

  .border_gray-1 {
    border-color: var(--colors-gray-1);
}

  .pb_28px {
    padding-bottom: 28px;
}

  .bg_gray-3 {
    background-color: var(--colors-gray-3);
}

  .pb_30px {
    padding-bottom: 30px;
}

  .bg_black-3 {
    background-color: var(--colors-black-3);
}

  .mr_7px {
    margin-right: 7px;
}

  .pb_16 {
    padding-bottom: 16px;
}

  .pt_16 {
    padding-top: 16px;
}

  .mr_2 {
    margin-right: 2px;
}

  .mt_40 {
    margin-top: 40px;
}

  .pt_24 {
    padding-top: 24px;
}

  .mt_32 {
    margin-top: 32px;
}

  .flex-wrap_nowrap {
    flex-wrap: nowrap;
}

  .pb_2 {
    padding-bottom: 2px;
}

  .mt_8 {
    margin-top: 8px;
}

  .items_start {
    align-items: start;
}

  .mb_3rem {
    margin-bottom: 3rem;
}

  .mt_50 {
    margin-top: 50px;
}

  .border_yellow-1 {
    border-color: var(--colors-yellow-1);
}

  .border_blue-1 {
    border-color: var(--colors-blue-1);
}

  .border_red-1 {
    border-color: var(--colors-red-1);
}

  .bg_purple-primary {
    background-color: var(--colors-purple-primary);
}

  .bg_red-1 {
    background-color: var(--colors-red-1);
}

  .border_black-3 {
    border-color: var(--colors-black-3);
}

  .bg_green {
    background-color: var(--colors-green);
}

  .bg_yellow-1 {
    background-color: var(--colors-yellow-1);
}

  .basis_20\% {
    flex-basis: 20%;
}

  .basis_80\% {
    flex-basis: 80%;
}

  .mb_32 {
    margin-bottom: 32px;
}

  .bg_0 {
    background-color: 0;
}

  .bg_black-5 {
    background-color: var(--colors-black-5);
}

  .bottom_15px {
    bottom: 15px;
}

  .fs_20 {
    font-size: 20px;
}

  .mr_auto {
    margin-right: auto;
}

  .mt_4 {
    margin-top: 4px;
}

  .ml_auto {
    margin-left: auto;
}

  .pb_100\% {
    padding-bottom: 100%;
}

  .bg_\#FFFFFF {
    background-color: #FFFFFF;
}

  .bg_200\%_100\% {
    background-size: 200% 100%;
}

  .mt_16px {
    margin-top: 16px;
}

  .bg_red-2 {
    background-color: var(--colors-red-2);
}

  .border_red {
    border-color: var(--colors-red);
}

  .border_green {
    border-color: var(--colors-green);
}

  .border_blue {
    border-color: var(--colors-blue);
}

  .bg_red {
    background-color: var(--colors-red);
}

  .ml_10px {
    margin-left: 10px;
}

  .pr_12px {
    padding-right: 12px;
}

  .top_50\% {
    top: 50%;
}

  .bg_rgba\(0\,_0\,_0\,_0\.4\) {
    background-color: rgba(0, 0, 0, 0.4);
}

  .bottom_10 {
    bottom: 10px;
}

  .left_48\% {
    left: 48%;
}

  .bg_black-1 {
    background-color: var(--colors-black-1);
}

  .bg_black-4 {
    background-color: var(--colors-black-4);
}

  .mr_6rem {
    margin-right: 6rem;
}

  .left_20 {
    left: 20px;
}

  .top_30 {
    top: 30px;
}

  .bg_gray\.100 {
    background-color: gray.100;
}

  .mb_32px {
    margin-bottom: 32px;
}

  .bg_purple-5 {
    background-color: var(--colors-purple-5);
}

  .top_38\% {
    top: 38%;
}

  .bg_\#FFFFFF91 {
    background-color: #FFFFFF91;
}

  .border_purple-4 {
    border-color: var(--colors-purple-4);
}

  .border_white {
    border-color: var(--colors-white);
}

  .border_black-5 {
    border-color: var(--colors-black-5);
}

  .font-style_b1 {
    font-style: b1;
}

  .leading_24px {
    line-height: 24px;
}

  .mt_-1rem {
    margin-top: -1rem;
}

  .pb_0\.5rem {
    padding-bottom: 0.5rem;
}

  .bg_\#e8ebee {
    background-color: #e8ebee;
}

  .mb_56 {
    margin-bottom: 56px;
}

  .leading_26px {
    line-height: 26px;
}

  .mt_-16 {
    margin-top: -16px;
}

  .bg_\#f0eeff {
    background-color: #f0eeff;
}

  .leading_28px {
    line-height: 28px;
}

  .fs_12 {
    font-size: 12px;
}

  .fs_14 {
    font-size: 14px;
}

  .border_purple-5 {
    border-color: var(--colors-purple-5);
}

  .pb_24px {
    padding-bottom: 24px;
}

  .pb_12px {
    padding-bottom: 12px;
}

  .mb_40px {
    margin-bottom: 40px;
}

  .pb_15px {
    padding-bottom: 15px;
}

  .mb_30px {
    margin-bottom: 30px;
}

  .mb_100px {
    margin-bottom: 100px;
}

  .mb_14 {
    margin-bottom: 14px;
}

  .pb_20px {
    padding-bottom: 20px;
}

  .pt_16px {
    padding-top: 16px;
}

  .mb_30 {
    margin-bottom: 30px;
}

  .pr_12 {
    padding-right: 12px;
}

  .bg_\#e9f0ff {
    background-color: #e9f0ff;
}

  .pb_0 {
    padding-bottom: 0;
}

  .mb_80px {
    margin-bottom: 80px;
}

  .left_-34 {
    left: -34px;
}

  .top_-28 {
    top: -28px;
}

  .left_-120 {
    left: -120px;
}

  .top_-71 {
    top: -71px;
}

  .items_end {
    align-items: end;
}

  .bg_\#E9ECF2 {
    background-color: #E9ECF2;
}

  .fs_16 {
    font-size: 16px;
}

  .bg_\#DEEEFF {
    background-color: #DEEEFF;
}

  .overflow-y_hidden {
    overflow-y: hidden;
}

  .mt_12 {
    margin-top: 12px;
}

  .pt_8 {
    padding-top: 8px;
}

  .mb_24px {
    margin-bottom: 24px;
}

  .self_center {
    align-self: center;
}

  .pb_10 {
    padding-bottom: 10px;
}

  .bg_\#4A357F80 {
    background-color: #4A357F80;
}

  .bg_\#5534AF {
    background-color: #5534AF;
}

  .bg_\#FFF {
    background-color: #FFF;
}

  .numeric_tabular-nums {
    font-variant-numeric: tabular-nums;
}

  .gap-y_16px {
    column-gap: 16px;
}

  .gap-x_24px {
    row-gap: 24px;
}

  .pb_6 {
    padding-bottom: 6px;
}

  .border_purple-2 {
    border-color: var(--colors-purple-2);
}

  .ml_4 {
    margin-left: 4px;
}

  .pt_4 {
    padding-top: 4px;
}

  .border_gray-4 {
    border-color: var(--colors-gray-4);
}

  .grid-cols_repeat\(3\,_1fr\) {
    grid-template-columns: repeat(3, 1fr);
}

  .pl_15px {
    padding-left: 15px;
}

  .pr_5px {
    padding-right: 5px;
}

  .ml_15px {
    margin-left: 15px;
}

  .bg_orange-2 {
    background-color: var(--colors-orange-2);
}

  .mb_12px {
    margin-bottom: 12px;
}

  .bg-img_linear-gradient\(180deg\,_\#EFB608_-86\.84\%\,_\#FFFFFF_71\.05\%\) {
    background-image: linear-gradient(180deg, #EFB608 -86.84%, #FFFFFF 71.05%);
}

  .bg-img_linear-gradient\(180deg\,_\#F14A68_-86\.84\%\,_\#FFFFFF_71\.05\%\) {
    background-image: linear-gradient(180deg, #F14A68 -86.84%, #FFFFFF 71.05%);
}

  .bg-img_linear-gradient\(180deg\,_\#96DEFF_-42\.94\%\,_\#FFFFFF_100\%\) {
    background-image: linear-gradient(180deg, #96DEFF -42.94%, #FFFFFF 100%);
}

  .bg-img_linear-gradient\(180deg\,_\#D0C2FF_-42\.94\%\,_\#FFFFFF_100\%\) {
    background-image: linear-gradient(180deg, #D0C2FF -42.94%, #FFFFFF 100%);
}

  .items_flex-start {
    align-items: flex-start;
}

  .items_flex-end {
    align-items: flex-end;
}

  .mask-image_radial-gradient\(farthest-side\,_transparent_75\%\,_white_76\%\) {
    mask-image: radial-gradient(farthest-side, transparent 75%, white 76%);
    -webkit-mask-image: radial-gradient(farthest-side, transparent 75%, white 76%);
}

  .left_25px {
    left: 25px;
}

  .right_25px {
    right: 25px;
}

  .mt_-80px {
    margin-top: -80px;
}

  .fs_32px {
    font-size: 32px;
}

  .mt_2 {
    margin-top: 2px;
}

  .font_700 {
    font-weight: 700;
}

  .font_medium {
    font-weight: var(--font-weights-medium);
}

  .self_stretch {
    align-self: stretch;
}

  .self_flex-end {
    align-self: flex-end;
}

  .fs_13px {
    font-size: 13px;
}

  .mb_16px {
    margin-bottom: 16px;
}

  .bg_\#8553CB {
    background-color: #8553CB;
}

  .font_500 {
    font-weight: 500;
}

  .border_\#277A9D {
    border-color: #277A9D;
}

  .leading_1\.5 {
    line-height: 1.5;
}

  .bottom_calc\(100\%_\+_8px\) {
    bottom: calc(100% + 8px);
}

  .bg_\#1B1B1B {
    background-color: #1B1B1B;
}

  .top_66px {
    top: 66px;
}

  .pt_28px {
    padding-top: 28px;
}

  .pb_16px {
    padding-bottom: 16px;
}

  .justify_flex-end {
    justify-content: flex-end;
}

  .font_normal {
    font-weight: normal;
}

  .flex_row-reverse {
    flex-direction: row-reverse;
}

  .mb_-40px {
    margin-bottom: -40px;
}

  .pt_2rem {
    padding-top: 2rem;
}

  .bg_\#FEF3E9 {
    background-color: #FEF3E9;
}

  .bg_\#E9FEF5 {
    background-color: #E9FEF5;
}

  .pt_1\.5rem {
    padding-top: 1.5rem;
}

  .mt_100px {
    margin-top: 100px;
}

  .mt_1\.5rem {
    margin-top: 1.5rem;
}

  .border_gray-2 {
    border-color: var(--colors-gray-2);
}

  .bg_purple-7 {
    background-color: var(--colors-purple-7);
}

  .mt_20 {
    margin-top: 20px;
}

  .bg_\#fff {
    background-color: #fff;
}

  .border_black-4 {
    border-color: var(--colors-black-4);
}

  .mr_-10px {
    margin-right: -10px;
}

  .mt_50px {
    margin-top: 50px;
}

  .mr_8px {
    margin-right: 8px;
}

  .mr_4px {
    margin-right: 4px;
}

  .mt_0\.2rem {
    margin-top: 0.2rem;
}

  .bottom_90px {
    bottom: 90px;
}

  .pr_2rem {
    padding-right: 2rem;
}

  .left_-100px {
    left: -100px;
}

  .top_0\.5rem {
    top: 0.5rem;
}

  .left_0\.5rem {
    left: 0.5rem;
}

  .mr_10px {
    margin-right: 10px;
}

  .top_1px {
    top: 1px;
}

  .pt_10px {
    padding-top: 10px;
}

  .pb_10px {
    padding-bottom: 10px;
}

  .bg_green-3 {
    background-color: var(--colors-green-3);
}

  .ml_3px {
    margin-left: 3px;
}

  .mr_5px {
    margin-right: 5px;
}

  .bg_blue-1 {
    background-color: var(--colors-blue-1);
}

  .border-style_dashed {
    border-style: dashed;
}

  .border-e_1px_solid {
    border-inline-end-width: 1px solid;
}

  .border_pink-1 {
    border-color: var(--colors-pink-1);
}

  .border-w_1px {
    border-width: 1px;
}

  .pt_25 {
    padding-top: 25px;
}

  .border_orange-2 {
    border-color: var(--colors-orange-2);
}

  .mb_15 {
    margin-bottom: 15px;
}

  .mt_6rem {
    margin-top: 6rem;
}

  .mt_25 {
    margin-top: 25px;
}

  .bg-img_url\(\'\@\/common\/assets\/images\/dashed-line\.png\'\) {
    background-image: url('@/common/assets/images/dashed-line.png');
}

  .bg_cover {
    background-size: cover;
}

  .top_35px {
    top: 35px;
}

  .left_100\% {
    left: 100%;
}

  .overflow-x_visible {
    overflow-x: visible;
}

  .justify_flex-start {
    justify-content: flex-start;
}

  .mt_22 {
    margin-top: 22px;
}

  .mt_56px {
    margin-top: 56px;
}

  .mt_7 {
    margin-top: 7px;
}

  .mt_34 {
    margin-top: 34px;
}

  .justify-items_center {
    justify-items: center;
}

  .border-b_gray-2 {
    border-bottom-color: var(--colors-gray-2);
}

  .border-bw_1px {
    border-bottom-width: 1px;
}

  .border-bottom-style_solid {
    border-bottom-style: solid;
}

  .mb_22px {
    margin-bottom: 22px;
}

  .top_-14px {
    top: -14px;
}

  .top_-10px {
    top: -10px;
}

  .top_-5px {
    top: -5px;
}

  .bg_\#EBEBEB {
    background-color: #EBEBEB;
}

  .pt_1rem {
    padding-top: 1rem;
}

  .pt_19px {
    padding-top: 19px;
}

  .pt_0px {
    padding-top: 0px;
}

  .pt_24px {
    padding-top: 24px;
}

  .bottom_5rem {
    bottom: 5rem;
}

  .left_1rem {
    left: 1rem;
}

  .mt_3rem {
    margin-top: 3rem;
}

  .mt_6px {
    margin-top: 6px;
}

  .border_black-4\! {
    border-color: var(--colors-black-4) !important;
}

  .border_gray {
    border-color: var(--colors-gray);
}

  .mt_26px {
    margin-top: 26px;
}

  .mb_5 {
    margin-bottom: 5px;
}

  .fs_xl {
    font-size: var(--font-sizes-xl);
}

  .top_-90px {
    top: -90px;
}

  .fs_x-large {
    font-size: x-large;
}

  .left_10px {
    left: 10px;
}

  .top_-20px {
    top: -20px;
}

  .pr_2px {
    padding-right: 2px;
}

  .top_-6px {
    top: -6px;
}

  .fs_6px {
    font-size: 6px;
}

  .top_15\% {
    top: 15%;
}

  .right_20\% {
    right: 20%;
}

  .mr_-80 {
    margin-right: -80px;
}

  .basis_30\% {
    flex-basis: 30%;
}

  .font-style_b3 {
    font-style: b3;
}

  .basis_33\% {
    flex-basis: 33%;
}

  .mt_10rem {
    margin-top: 10rem;
}

  .mt_4rem {
    margin-top: 4rem;
}

  .mt_0rem {
    margin-top: 0rem;
}

  .mb_0rem {
    margin-bottom: 0rem;
}

  .mt_5\.5rem {
    margin-top: 5.5rem;
}

  .right_10px {
    right: 10px;
}

  .items_stretch {
    align-items: stretch;
}

  .justify_start {
    justify-content: start;
}

  .mt_26 {
    margin-top: 26px;
}

  .pb_4px {
    padding-bottom: 4px;
}

  .mr_8 {
    margin-right: 8px;
}

  .mt_45px {
    margin-top: 45px;
}

  .bottom_1\.5rem {
    bottom: 1.5rem;
}

  .grid-cols_repeat\(1\,_minmax\(0\,_1fr\)\) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}

  .bottom_70 {
    bottom: 70px;
}

  .mr_1rem {
    margin-right: 1rem;
}

  .pt_26 {
    padding-top: 26px;
}

  .top_-15_px {
    top: -15 px;
}

  .grow_1 {
    flex-grow: 1;
}

  .bg_purple-2 {
    background-color: var(--colors-purple-2);
}

  .mb_7rem {
    margin-bottom: 7rem;
}

  .mt_1\.8rem {
    margin-top: 1.8rem;
}

  .bg_\#F6F6F8 {
    background-color: #F6F6F8;
}

  .mb_4rem {
    margin-bottom: 4rem;
}

  .bottom_0\.2rem {
    bottom: 0.2rem;
}

  .bottom_20 {
    bottom: 20px;
}

  .checked\:border_1px_solid_\{colors\.purple-primary\}:is(:checked, [data-checked], [aria-checked=true], [data-state="checked"]) {
    border: 1px solid var(--colors-purple-primary);
}

  .disabled\:border_1px_solid_\{colors\.gray-1\}:is(:disabled, [disabled], [data-disabled]) {
    border: 1px solid var(--colors-gray-1);
}

  .\[\&\:\:-webkit-scrollbar\]\:d_none::-webkit-scrollbar {
    display: none;
}

  .last\:border-b_none:last-child {
    border-bottom: none;
}

  .\[\&\:disabled\]\:text_purple-3:disabled {
    color: var(--colors-purple-3);
}

  .\[\&\:disabled\]\:text_gray-1:disabled {
    color: var(--colors-gray-1);
}

  .\[\&\:disabled\]\:text_green-2:disabled {
    color: var(--colors-green-2);
}

  .\[\&_svg_path\]\:fill_currentColor svg path {
    fill: currentColor;
}

  .\[\&_svg\]\:w_16px svg {
    width: 16px;
}

  .\[\&_svg\]\:h_16px svg {
    height: 16px;
}

  .\[\&_svg_path\]\:fill_\#465c73 svg path {
    fill: #465c73;
}

  .\[\&_svg\]\:w_20px svg {
    width: 20px;
}

  .\[\&_svg\]\:h_20px svg {
    height: 20px;
}

  .\[\&_p\]\:m_0_0_16px p {
    margin: 0 0 16px;
}

  .\[\&_ul\]\:ps_24px\! ul {
    padding-inline-start: 24px !important;
}

  .\[\&_ul\]\:my_12px ul {
    margin-block: 12px;
}

  .\[\&_ol\]\:ps_24px\! ol {
    padding-inline-start: 24px !important;
}

  .\[\&_ol\]\:my_12px ol {
    margin-block: 12px;
}

  .\[\&_li\]\:d_list-item\! li {
    display: list-item !important;
}

  .\[\&_h1\,_\&_h2\,_\&_h3\]\:my_16px h1,.\[\&_h1\,_\&_h2\,_\&_h3\]\:my_16px h2,.\[\&_h1\,_\&_h2\,_\&_h3\]\:my_16px h3 {
    margin-block: 16px;
}

  .\[\&_img\]\:max-w_100\% img {
    max-width: 100%;
}

  .\[\&_img\]\:h_auto img {
    height: auto;
}

  .\[\&_video\]\:w_100\% video {
    width: 100%;
}

  .\[\&_video\]\:h_100\% video {
    height: 100%;
}

  .\[\&_video\]\:d_block video {
    display: block;
}

  .\[\&_video\]\:object_contain video {
    object-fit: contain;
}

  .\[\&\:\:-webkit-slider-thumb\]\:appearance_none::-webkit-slider-thumb {
    appearance: none;
    -webkit-appearance: none;
}

  .\[\&\:\:-webkit-slider-thumb\]\:-webkit-appearance_none::-webkit-slider-thumb {
    -webkit-appearance: none;
}

  .\[\&\:\:-webkit-slider-thumb\]\:w_14px::-webkit-slider-thumb {
    width: 14px;
}

  .\[\&\:\:-webkit-slider-thumb\]\:h_14px::-webkit-slider-thumb {
    height: 14px;
}

  .\[\&\:\:-webkit-slider-thumb\]\:rounded_50\%::-webkit-slider-thumb {
    border-radius: 50%;
}

  .\[\&\:\:-webkit-slider-thumb\]\:bg_purple-2::-webkit-slider-thumb {
    background: var(--colors-purple-2);
}

  .\[\&\:\:-webkit-slider-thumb\]\:cursor_pointer::-webkit-slider-thumb {
    cursor: pointer;
}

  .\[\&_svg\]\:w_30px svg {
    width: 30px;
}

  .\[\&_svg\]\:h_30px svg {
    height: 30px;
}

  .\[\&_svg\]\:text_white svg {
    color: var(--colors-white);
}

  .\[\&_svg\]\:w_40px svg {
    width: 40px;
}

  .\[\&_svg\]\:h_40px svg {
    height: 40px;
}

  .\[\&_svg\]\:w_32px svg {
    width: 32px;
}

  .\[\&_svg\]\:h_32px svg {
    height: 32px;
}

  .\[\&_svg\]\:w_24px svg {
    width: 24px;
}

  .\[\&_svg\]\:h_24px svg {
    height: 24px;
}

  .after\:pos_absolute::after {
    position: absolute;
}

  .after\:transform_translateX\(-50\%\)::after {
    transform: translateX(-50%);
}

  .after\:border-l_6px_solid_transparent::after {
    border-left: 6px solid transparent;
}

  .after\:border-r_6px_solid_transparent::after {
    border-right: 6px solid transparent;
}

  .after\:border-t_6px_solid_\#1B1B1B::after {
    border-top: 6px solid #1B1B1B;
}

  .\[\&_\>_div\:first-child\]\:p_4px > div:first-child {
    padding: 4px;
}

  .\[\&_\>_div\:first-child\]\:rounded_10px > div:first-child {
    border-radius: 10px;
}

  .placeholder\:text_start::placeholder,.placeholder\:text_start[data-placeholder] {
    text-align: start;
}

  .placeholder\:text_end::placeholder,.placeholder\:text_end[data-placeholder] {
    text-align: end;
}

  .disabled\:text_black-4:is(:disabled, [disabled], [data-disabled]) {
    color: var(--colors-black-4);
}

  .placeholder\:text_black-4::placeholder,.placeholder\:text_black-4[data-placeholder] {
    color: var(--colors-black-4);
}

  .\[\&\:\:before\]\:d_block::before {
    display: block;
}

  .\[\&\:\:before\]\:w_8px::before {
    width: 8px;
}

  .\[\&\:\:before\]\:h_8px::before {
    height: 8px;
}

  .\[\&\:\:before\]\:rounded_50\%::before {
    border-radius: 50%;
}

  .\[\&\:\:before\]\:pos_absolute::before {
    position: absolute;
}

  .\[\&\:\:before\]\:transform_translate\(-50\%\,_-50\%\)::before {
    transform: translate(-50%, -50%);
}

  .\[\&\:\:-webkit-inner-spin-button\]\:-webkit-appearance_none::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

  .\[\&\:\:-webkit-inner-spin-button\]\:m_0::-webkit-inner-spin-button {
    margin: 0;
}

  .\[\&\:\:-webkit-outer-spin-button\]\:-webkit-appearance_none::-webkit-outer-spin-button {
    -webkit-appearance: none;
}

  .\[\&\:\:-webkit-outer-spin-button\]\:m_0::-webkit-outer-spin-button {
    margin: 0;
}

  .\[\&\]\:appearance_textfield {
    appearance: textfield;
    -webkit-appearance: textfield;
}

  .\[\&_\>_div\]\:w_100\%\! > div {
    width: 100% !important;
}

  .\[\&_\>_div\]\:h_100\%\! > div {
    height: 100% !important;
}

  .checked\:bg_purple-primary:is(:checked, [data-checked], [aria-checked=true], [data-state="checked"]) {
    background-color: var(--colors-purple-primary);
}

  .disabled\:bg_gray-1:is(:disabled, [disabled], [data-disabled]) {
    background-color: var(--colors-gray-1);
}

  .\[\&_\>_\*\]\:shrink_0 > * {
    flex-shrink: 0;
}

  .\[\&\:disabled\]\:bg_purple-6:disabled {
    background-color: var(--colors-purple-6);
}

  .\[\&\:disabled\]\:border_purple-3:disabled {
    border-color: var(--colors-purple-3);
}

  .\[\&\:disabled\]\:border_gray-1:disabled {
    border-color: var(--colors-gray-1);
}

  .\[\&\:disabled\]\:bg_green-3:disabled {
    background-color: var(--colors-green-3);
}

  .\[\&\,_\&_\*\]\:font_iran-yekan\!,.\[\&\,_\&_\*\]\:font_iran-yekan\! * {
    font-family: iran-yekan !important;
}

  .\[\&_p\]\:fs_14px\! p {
    font-size: 14px !important;
}

  .\[\&_ul\]\:list_disc\! ul {
    list-style-type: disc !important;
}

  .\[\&_ul\]\:list_outside ul {
    list-style-position: outside;
}

  .\[\&_ul\]\:fs_14px\! ul {
    font-size: 14px !important;
}

  .\[\&_ol\]\:list_decimal\! ol {
    list-style-type: decimal !important;
}

  .\[\&_ol\]\:list_outside ol {
    list-style-position: outside;
}

  .\[\&_ol\]\:fs_14px\! ol {
    font-size: 14px !important;
}

  .\[\&_li\]\:mb_6px li {
    margin-bottom: 6px;
}

  .\[\&_li\]\:fs_14px\! li {
    font-size: 14px !important;
}

  .\[\&_h1\,_\&_h1_\*\]\:font_iran-yekan-bold\! h1,.\[\&_h1\,_\&_h1_\*\]\:font_iran-yekan-bold\! h1 * {
    font-family: iran-yekan-bold !important;
}

  .\[\&_h1\,_\&_h1_\*\]\:fs_20px\! h1,.\[\&_h1\,_\&_h1_\*\]\:fs_20px\! h1 * {
    font-size: 20px !important;
}

  .\[\&_h1\,_\&_h1_\*\]\:font_700\! h1,.\[\&_h1\,_\&_h1_\*\]\:font_700\! h1 * {
    font-weight: 700 !important;
}

  .\[\&_h1\,_\&_h1_\*\]\:leading_1\.5 h1,.\[\&_h1\,_\&_h1_\*\]\:leading_1\.5 h1 * {
    line-height: 1.5;
}

  .\[\&_h2\,_\&_h2_\*\]\:font_iran-yekan-bold\! h2,.\[\&_h2\,_\&_h2_\*\]\:font_iran-yekan-bold\! h2 * {
    font-family: iran-yekan-bold !important;
}

  .\[\&_h2\,_\&_h2_\*\]\:fs_18px\! h2,.\[\&_h2\,_\&_h2_\*\]\:fs_18px\! h2 * {
    font-size: 18px !important;
}

  .\[\&_h2\,_\&_h2_\*\]\:font_700\! h2,.\[\&_h2\,_\&_h2_\*\]\:font_700\! h2 * {
    font-weight: 700 !important;
}

  .\[\&_h2\,_\&_h2_\*\]\:leading_1\.5 h2,.\[\&_h2\,_\&_h2_\*\]\:leading_1\.5 h2 * {
    line-height: 1.5;
}

  .\[\&_h3\,_\&_h3_\*\]\:font_iran-yekan-bold\! h3,.\[\&_h3\,_\&_h3_\*\]\:font_iran-yekan-bold\! h3 * {
    font-family: iran-yekan-bold !important;
}

  .\[\&_h3\,_\&_h3_\*\]\:fs_16px\! h3,.\[\&_h3\,_\&_h3_\*\]\:fs_16px\! h3 * {
    font-size: 16px !important;
}

  .\[\&_h3\,_\&_h3_\*\]\:font_700\! h3,.\[\&_h3\,_\&_h3_\*\]\:font_700\! h3 * {
    font-weight: 700 !important;
}

  .\[\&_h3\,_\&_h3_\*\]\:leading_1\.5 h3,.\[\&_h3\,_\&_h3_\*\]\:leading_1\.5 h3 * {
    line-height: 1.5;
}

  .\[\&_video\]\:bg_black video {
    background-color: var(--colors-black);
}

  .after\:content_\"\"::after {
    content: "";
}

  .after\:top_100\%::after {
    top: 100%;
}

  .after\:left_50\%::after {
    left: 50%;
}

  .\[\&_\>_div\:first-child\]\:ml_auto > div:first-child {
    margin-left: auto;
}

  .\[\&_\>_div\:first-child\]\:mr_0 > div:first-child {
    margin-right: 0;
}

  .\[\&_\>_div\:first-child\]\:bg_\#F5F5F5 > div:first-child {
    background-color: #F5F5F5;
}

  .disabled\:bg_gray-3:is(:disabled, [disabled], [data-disabled]) {
    background-color: var(--colors-gray-3);
}

  .\[\&\:\:before\]\:content_\"\"::before {
    content: "";
}

  .\[\&\:\:before\]\:bg_purple-3::before {
    background-color: var(--colors-purple-3);
}

  .\[\&\:\:before\]\:top_50\%::before {
    top: 50%;
}

  .\[\&\:\:before\]\:left_50\%::before {
    left: 50%;
}

  .\[\&\:\:before\]\:bg_gray-1::before {
    background-color: var(--colors-gray-1);
}

  .\[\&_a\,_\&_a\:visited\]\:text_purple-primary\! a,.\[\&_a\,_\&_a\:visited\]\:text_purple-primary\! a:visited {
    color: var(--colors-purple-primary) !important;
}

  .\[\&_a\,_\&_a\:visited\]\:text-decor_underline\! a,.\[\&_a\,_\&_a\:visited\]\:text-decor_underline\! a:visited {
    text-decoration: underline !important;
}

  .\[\&_a\,_\&_a\:visited\]\:underline-offset_2px a,.\[\&_a\,_\&_a\:visited\]\:underline-offset_2px a:visited {
    text-underline-offset: 2px;
}

  .\[\&_a\,_\&_a\:visited\]\:cursor_pointer a,.\[\&_a\,_\&_a\:visited\]\:cursor_pointer a:visited {
    cursor: pointer;
}

  .\[\&_a\,_\&_a\:visited\]\:overflow-wrap_anywhere a,.\[\&_a\,_\&_a\:visited\]\:overflow-wrap_anywhere a:visited {
    overflow-wrap: anywhere;
}

  .focus\:border_1px_solid_\{colors\.purple-3\}:is(:focus, [data-focus]) {
    border: 1px solid var(--colors-purple-3);
}

  .active\:transform_scale\(0\.95\):is(:active, [data-active]) {
    transform: scale(0.95);
}

  @media screen and (min-width: 28.125rem) {
    .xl\:w_100\% {
      width: 100%;
}
    .xl\:mx_0 {
      margin-inline: 0;
}
}
}